import { useTranslation } from 'react-i18next'

interface IProps {
  value: number
}

const CertificateType = ({ value }: IProps) => {
  const { t } = useTranslation()
  
  return <span>{value === 0 ? t('reusables.certificateType.individual') : t('reusables.certificateType.group')}</span>
}

export default CertificateType
